import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import copyLinkFunction from 'components/Dashboard/utilities/copyLinkFunction';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';
import { TwitterShareButton } from 'react-share';

const ManifestoShare = (props) => {
  const location = useLocation();
  const isMobile = useIsMobile();

  const { election2026 } = props;

  const [showActions, setShowActions] = useState(false);
  const actionsElement = useRef(null);
  const hideActions = () => {
    setShowActions(false);
  };
  useOutsideElement(actionsElement, hideActions);
  const { width, top, left, height } = actionsElement?.current?.getBoundingClientRect() ?? {};
  const searchTrackingStart = `${location.search === '' ? '?' : '&'}`;
  return (
    <>
      <div className='position-relative' ref={actionsElement}>
        <button
          className={`general-button rounded-pill paragraph-p3 bg-light-blue text-white px-lg-4 specific-y-padding-6 px-3 ml-2 ml-lg-0`}
          onClick={() => {
            setShowActions(!showActions);
          }}
        >
          {isMobile ? (
            <span className='icon-share paragraph-p3' />
          ) : (
            <span
              className={`d-inline-block dropdown-item-element dropdown-item-element-9 ${showActions ? 'open' : ''}`}
            >
              Share
            </span>
          )}
        </button>
        {showActions && (
          <div
            className='position-fixed rounded border bg-main-white box-outstanding adjustment-of-position py-2'
            style={{
              width: '320px',
              top: `${top + height + 5}px`,
              left: `${left + width - 320}px`,
            }}
          >
            <div
              className='d-flex px-4 py-3 pointer action-state-hover'
              onClick={(e) => {
                const url = `${import.meta.env.VITE_APP_APPURL}${location.pathname}${location.search.includes('utm_source') ? '' : `?utm_source=share-button`}`;
                copyLinkFunction({ e, url, closeFunction: () => setShowActions(false) });
              }}
            >
              <div className='pt-1 analytics-share-icon-container'>
                <span className='icon-share-link title-h5-m' />
              </div>
              <div className='pl-3'>
                <p className='font-weight-bold mb-1'>Copy link to the tool</p>
                <p className='main-light-text mb-0'>Share a link to the manifesto tracker with anyone</p>
              </div>
            </div>
            <div
              className='d-flex px-4 py-3 pointer action-state-hover'
              onClick={(e) => {
                const url = `${import.meta.env.VITE_APP_APPURL}${location.pathname}${location.search}${location.search.includes('utm_source') ? '' : `${searchTrackingStart}utm_source=share-button`}${location.hash}`;
                copyLinkFunction({ e, url, closeFunction: () => setShowActions(false) });
              }}
            >
              <div className='pt-1 analytics-share-icon-container'>
                <span className='icon-share-link title-h5-m' />
              </div>
              <div className='pl-3'>
                <p className='font-weight-bold mb-1'>Copy link to this search</p>
                <p className='main-light-text mb-0'>Share a link to this specific search with anyone</p>
              </div>
            </div>
            <TwitterShareButton
              url={`${import.meta.env.VITE_APP_APPURL}/${location.pathname}/manifestos?utm-source=twitter-share-button`}
              title={'Compare UK party manifestos on any issue:'}
              className='w-100 text-left'
            >
              <div className='d-flex px-4 py-3 pointer action-state-hover'>
                <div className='pt-1 analytics-share-icon-container'>
                  <span className='icon-twitter-x title-h5-m' />
                </div>
                <div className='pl-3'>
                  <p className='font-weight-bold mb-1'>
                    Share {election2026 ? 'manifesto tracker' : 'election hub'} on X
                  </p>
                  <p className='main-light-text mb-0'>
                    Share {election2026 ? 'manifesto tracker' : 'election hub'} (without a specific search term) on X
                  </p>
                </div>
              </div>
            </TwitterShareButton>
          </div>
        )}
      </div>
    </>
  );
};

export default ManifestoShare;
